/**
 * Types of flight status values for real time flights
 */
enum FlightStatus {
    Unknown,
    Scheduled,
    Active,
    Redirected,
    Landed,
    Diverted,
    Cancelled,
    NotOperational,
}

export default FlightStatus;
